import {inject, Injectable} from '@angular/core';
import {SNACKBAR_DELAY} from '../constants/app';
import {MatSnackBar} from '@angular/material/snack-bar';
import {ErrorMessage, ErrorMessageLabel} from '../constants/error';
import {ErrorManagerSnackbarComponent} from '../common/snackbars/error-manager-snackbar/error-manager-snackbar.component';

@Injectable({
	providedIn: 'root',
})
export class ErrorManagerService {
	snackBar = inject(MatSnackBar);

	handle(message: ErrorMessage | string = ErrorMessageLabel[ErrorMessage.Default]) {
		return this.snackBar.openFromComponent(ErrorManagerSnackbarComponent, {
			data: {message: message},
			duration: SNACKBAR_DELAY,
			panelClass: 'error-snackbar-container',
		});
	}
}
